import { TitleManagementMode } from "./title-management-mode";

export class UpdateCompilationRequest {
  assetIds: number[] | null = null;
  skipMarkersToUseIds: number[] | null = null;
  keepFirstIntroOfTitles: boolean | null = null;
  keepLastCreditsOfTitles: boolean | null = null;
  titleManagementMode: TitleManagementMode | null = null;

  constructor(init?: Partial<UpdateCompilationRequest>) {
    Object.assign(this, init);
  }
}
